import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "sidebar-wrapper" }
const _hoisted_2 = { class: "menu-label" }

import { ref, watch, markRaw } from "vue";
import { useRoute } from "vue-router";
import {
  Odometer,
  OfficeBuilding,
  Ship,
  List,
  Key,
  Document,
  Lock,
  Coin,
  // FolderOpened, // 归档管理入口暂隐藏，恢复时取消注释（含下方菜单项）
} from "@element-plus/icons-vue";
import type { Component } from "vue";

interface MenuItem {
  index: string;
  label: string;
  icon: Component;
  /** 待开发禁用：置灰不可点（悬浮提示"待开发"），功能就绪后移除即可恢复 */
  disabled?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SidebarMenu',
  setup(__props) {

const route = useRoute();

// 菜单控件
const activeMenu = ref<string>("");
const updateActiveMenu = () => {
  activeMenu.value = route.name as string;
};
updateActiveMenu();
watch(() => route.name, updateActiveMenu);

// 菜单配置（markRaw 避免 Vue 对图标组件做不必要的响应式包装）
const menuItems = ref<MenuItem[]>([
  { index: "overall", label: "信息总览", icon: markRaw(Odometer) },
  {
    index: "organizationList",
    label: "集团列表",
    icon: markRaw(OfficeBuilding),
  },
  { index: "shipList", label: "船舶列表", icon: markRaw(Ship) },
  { index: "upgradeList", label: "推送记录", icon: markRaw(List) },
  {
    index: "generateEndpointConnector",
    label: "生成三元组",
    icon: markRaw(Key),
  },
  { index: "ccsReport", label: "报文发送", icon: markRaw(Document) },
  {
    index: "certBatchManagement",
    label: "证书与终端",
    icon: markRaw(Lock),
  },
  {
    index: "exchangeRate",
    label: "汇率管理",
    icon: markRaw(Coin),
    // 入口禁用（待开发）：需要恢复"不可点击"时取消下行注释即可
    // disabled: true,
  },
  // 归档管理入口暂隐藏：需要展示时取消下方注释（同时恢复 FolderOpened 导入）
  // {
  //   index: "archiveManagement",
  //   label: "归档管理",
  //   icon: markRaw(FolderOpened),
  // },
  // 账号管理入口在右上角头像下拉框中（不占侧边栏）
]);

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "topnav-logo" }, null, -1)),
    _createVNode(_component_el_scrollbar, { class: "scrollbar" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_menu, {
          ref: "menuRef",
          "default-active": activeMenu.value,
          class: "sidebar-menu",
          router: true,
          "background-color": "transparent",
          "text-color": "#475569",
          "active-text-color": "#ffffff"
        }, {
          default: _withCtx(() => [
            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "menu-section-label" }, "NAVIGATION", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuItems.value, (item) => {
              return (_openBlock(), _createBlock(_component_el_menu_item, {
                key: item.index,
                index: item.index,
                route: { name: item.index },
                disabled: !!item.disabled,
                title: item.disabled ? '待开发' : undefined,
                class: "menu-item"
              }, {
                title: _withCtx(() => [
                  _createElementVNode("span", _hoisted_2, _toDisplayString(item.label), 1)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, { class: "menu-icon" }, {
                    default: _withCtx(() => [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon)))
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["index", "route", "disabled", "title"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["default-active"])
      ]),
      _: 1
    }),
    _cache[2] || (_cache[2] = _createStaticVNode("<div class=\"sidebar-footer\" data-v-4628f125><div class=\"footer-line\" data-v-4628f125></div><div class=\"footer-content\" data-v-4628f125><div class=\"footer-brand\" data-v-4628f125><span class=\"brand-dot\" data-v-4628f125></span><span class=\"brand-text\" data-v-4628f125>Racern IoT Platform</span></div><div class=\"footer-version\" data-v-4628f125>v1.0.0 · 管理端</div></div></div>", 1))
  ]))
}
}

})